import { PublicKey } from "@solana/web3.js";

export const COLLECTOR = new PublicKey(
  "ETkrpM1XPWhM4qb1KN4gYdzQNbFWDvgAMtDVwAGkqEvQ"
);

export const TOKEN_MANAGER_ADDRESS = new PublicKey(
  "39xubSermwXqcSPu2qEHSspGVmsVZYBnA8RbFqhMLbFK"
);
